import EcommerceCourses from './EcommerceCourses';

export default EcommerceCourses;